import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'

import { AssignmentTable } from '../../../../tables/assignment-table'

const Assignments: React.FunctionComponent = observer(() => {
  const { assignmentStore } = useStores()
  const match = useRouteMatch<any>('/people/groups/:id/assignments')
  const groupID = Number(match?.params.id)

  const [tableHelper] = useState(
    new TableHelper('list_group_assignments', 'assignments', 'groups', groupID, 'active'),
  )

  return (
    <AssignmentTable
      forceLoading={assignmentStore.triggerRefresh}
      filter="active"
      tableHelper={tableHelper}
    />
  )
})

export const GroupsAssignmentsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Assignments',
    path: `/people/groups/${id}/assignments`,
    component: () => <Assignments />,
  }
}
